import { render, staticRenderFns } from "./indicatorsFieldCorrect.vue?vue&type=template&id=06501f28&scoped=true"
import script from "./indicatorsFieldCorrect.vue?vue&type=script&lang=js"
export * from "./indicatorsFieldCorrect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06501f28",
  null
  
)

export default component.exports